// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qa_a bhl_sl bhl_uy","ForumSearch__img":"qa_b","ForumSearch__searchAdsAndShoppingAds":"qa_c","ForumSearch__results--empty":"qa_e"};